import { IClickToCallMeData } from '@vfit/shared/models';
import { purify } from '@vfit/shared/themes';

export const organizeClickToCallSubmitted = (cmsData: IClickToCallMeData, phoneNumber: string) => ({
  successSubmission: {
    headline: purify([cmsData?.clicktocall?.successSubmission?.headline || ''])?.[0] || '',
    img: purify([cmsData?.clicktocall?.successSubmission?.img || ''])?.[0] || '',
    imgMobile: purify([cmsData?.clicktocall?.successSubmission?.imgMobile || ''])?.[0] || '',
    message:
      purify([
        cmsData?.clicktocall?.successSubmission?.message?.replace(
          '$PHONE_NUMBER',
          `<b>${phoneNumber}</b>`
        ),
      ])?.[0] || '',
  },
});
